import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { Badge } from "../../components/base/badge";
import { Card, CardContent, CardHeader, CardTitle, } from "../../components/base/card";
const matchField = (flattened, field, nextFields) => {
    if (!nextFields || nextFields.length === 0) {
        const regex = new RegExp(`${field}:\\s*(.+)$`, "i");
        return flattened.match(regex)?.[1]?.trim();
    }
    const lookAhead = nextFields.map((name) => `${name}:`).join("|");
    const regex = new RegExp(`${field}:\\s*(.+?)(?=\\s+(?:${lookAhead})|$)`, "i");
    return flattened.match(regex)?.[1]?.trim();
};
export const parsePaymentSummaryContent = (content) => {
    if (!content)
        return null;
    const flattened = content.replace(/\s+/g, " ").trim();
    if (!flattened.includes("Payment Request"))
        return null;
    const requestNumber = matchField(flattened, "Request Number", [
        "Title",
        "Amount",
        "Status",
        "Paid At",
        "Trade No",
        "Payment Method",
    ]);
    const amountRaw = flattened.match(/Amount:\s*TWD\s*(\d+)/i)?.[1];
    const status = matchField(flattened, "Status", [
        "Paid At",
        "Trade No",
        "Payment Method",
    ]);
    if (!requestNumber || !amountRaw || !status)
        return null;
    const amountTwd = Number.parseInt(amountRaw, 10);
    if (Number.isNaN(amountTwd))
        return null;
    const title = matchField(flattened, "Title", ["Amount"]);
    const paidAt = matchField(flattened, "Paid At", [
        "Trade No",
        "Payment Method",
    ]);
    const tradeNo = matchField(flattened, "Trade No", ["Payment Method"]);
    const paymentMethod = matchField(flattened, "Payment Method");
    return {
        requestNumber,
        title,
        amountTwd,
        currency: "TWD",
        status: status.toLowerCase(),
        paidAt,
        tradeNo,
        paymentMethod,
    };
};
export const PaymentSummaryCard = ({ summary, labels, className, }) => {
    const statusClassName = useMemo(() => {
        if (summary.status === "succeeded") {
            return "border-emerald-200 bg-emerald-100 text-emerald-800";
        }
        if (summary.status === "failed") {
            return "border-red-200 bg-red-100 text-red-800";
        }
        return "border-slate-200 bg-slate-100 text-slate-700";
    }, [summary.status]);
    return (_jsxs(Card, { className: className ?? "my-4", children: [_jsx(CardHeader, { className: "pb-3", children: _jsxs("div", { className: "flex items-center justify-between gap-2", children: [_jsx(CardTitle, { className: "text-base", children: labels.title }), _jsx(Badge, { variant: "secondary", className: statusClassName, children: labels.getStatusLabel(summary.status) })] }) }), _jsxs(CardContent, { className: "space-y-3", children: [_jsx("p", { className: "text-sm text-muted-foreground", children: summary.title || labels.defaultItemDesc }), _jsxs("div", { className: "text-sm", children: [_jsxs("div", { children: [labels.amount, ":", " ", _jsxs("span", { className: "font-medium", children: [summary.currency || "TWD", " ", summary.amountTwd] })] }), _jsxs("div", { children: [labels.orderNo, ":", " ", _jsx("span", { className: "font-mono text-xs", children: summary.requestNumber })] }), summary.paidAt && labels.paidAt && (_jsxs("div", { children: [labels.paidAt, ": ", new Date(summary.paidAt).toLocaleString()] })), summary.tradeNo && labels.tradeNo && (_jsxs("div", { children: [labels.tradeNo, ":", " ", _jsx("span", { className: "font-mono text-xs", children: summary.tradeNo })] })), summary.paymentMethod && labels.paymentMethod && (_jsxs("div", { children: [labels.paymentMethod, ": ", summary.paymentMethod] }))] })] })] }));
};
export default PaymentSummaryCard;
//# sourceMappingURL=PaymentSummaryCard.js.map